export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return 'N/D';
  }

  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  if (absValue >= 1_000_000_000) {
    return `${sign}R$ ${(absValue / 1_000_000_000).toFixed(1).replace('.', ',')} B`;
  }

  if (absValue >= 1_000_000) {
    return `${sign}R$ ${(absValue / 1_000_000).toFixed(1).replace('.', ',')} M`;
  }

  if (absValue >= 1_000) {
    return `${sign}R$ ${(absValue / 1_000).toFixed(1).replace('.', ',')} K`;
  }

  return `${sign}R$ ${absValue.toFixed(2).replace('.', ',')}`;
};
